/* ag-menu-scroll.js — Menú lateral (hamburguesa) en celular:
   1) Indicador de desplazamiento propio (iOS no deja forzar el scrollbar nativo). Si el navegador ya muestra
      un scrollbar nativo con ancho (Android/escritorio), esta barra se oculta para no duplicar.
   2) Corrección de altura: el tema fija --block-height del bloque del menú al cargar o al cerrar un submenú y a veces
      queda más alto que el contenido (espacio en blanco antes de las redes sociales). En el nivel principal se
      ajusta a la altura real de la lista. */
(function () {
  'use strict';
  try {
    var MQ = window.matchMedia('(max-width: 749px)');

    /* ---------- 2) Altura del bloque del menú ---------- */
    var fixTimer = 0;
    function fixMenuHeight() {
      fixTimer = 0;
      var mb = document.querySelector('.drawer--header .mobile-menu__block--menu');
      if (!mb) return;
      var nav = mb.querySelector('[data-sliderule-pane]');
      var level = nav ? parseInt(nav.getAttribute('data-sliderule-pane'), 10) : 0;
      if (level > 0) return; /* submenú abierto: el tema calcula su altura */
      var main = mb.querySelector('.drawer__main-menu') || mb.querySelector('[data-links]');
      if (!main || !main.lastElementChild) return;
      var h = main.scrollHeight;
      var last = main.lastElementChild.getBoundingClientRect().bottom - main.getBoundingClientRect().top;
      if (last > 0 && last < h) h = last;
      h = Math.ceil(h);
      if (!(h > 0)) return;
      var cur = parseFloat(mb.style.getPropertyValue('--block-height')) || 0;
      if (Math.abs(cur - h) > 4) mb.style.setProperty('--block-height', h + 'px');
    }
    function scheduleFix(delay) {
      if (fixTimer) clearTimeout(fixTimer);
      fixTimer = setTimeout(fixMenuHeight, delay || 120);
    }

    /* ---------- 1) Indicador de scroll ---------- */
    function init() {
      var sc = document.querySelector('.drawer--header .drawer__content__scroll');
      if (!sc || sc.__agBar) return;
      var host = sc.parentElement;
      if (!host) return;
      sc.__agBar = true;

      var bar = document.createElement('div');
      bar.className = 'ag-scrollbar';
      bar.setAttribute('aria-hidden', 'true');
      var thumb = document.createElement('div');
      thumb.className = 'ag-scrollbar__thumb';
      bar.appendChild(thumb);
      host.appendChild(bar);

      var raf = 0;
      function update() {
        raf = 0;
        var sh = sc.scrollHeight;
        var ch = sc.clientHeight;
        var nativeVisible = sc.offsetWidth - sc.clientWidth > 0;
        if (!MQ.matches || nativeVisible || ch <= 0 || sh <= ch + 2) {
          bar.style.display = 'none';
          return;
        }
        bar.style.display = 'block';
        var trackH = bar.clientHeight;
        if (trackH <= 0) return;
        var th = Math.max(48, Math.round((trackH * ch) / sh));
        var max = sh - ch;
        var top = max > 0 ? Math.round(((trackH - th) * sc.scrollTop) / max) : 0;
        top = Math.min(Math.max(top, 0), trackH - th);
        thumb.style.height = th + 'px';
        thumb.style.transform = 'translateY(' + top + 'px)';
      }
      function schedule() {
        if (!raf) raf = window.requestAnimationFrame(update);
      }

      sc.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', function () { schedule(); scheduleFix(200); });
      window.addEventListener('orientationchange', function () { schedule(); scheduleFix(300); });

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(schedule);
        ro.observe(sc);
        Array.prototype.forEach.call(sc.children, function (c) { ro.observe(c); });
      }
      if (window.MutationObserver) {
        var drawer = sc.closest('.drawer');
        if (drawer) {
          new MutationObserver(function () {
            schedule();
            scheduleFix(150);
            setTimeout(fixMenuHeight, 700);
          }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
        }
        new MutationObserver(schedule).observe(sc, { childList: true, subtree: true });

        var mb = sc.querySelector('.mobile-menu__block--menu');
        if (mb) {
          /* cuando el tema reescribe --block-height o cambia de nivel de submenú */
          new MutationObserver(function () { scheduleFix(150); }).observe(mb, { attributes: true, attributeFilter: ['style'] });
          var nav = mb.querySelector('[data-sliderule-pane]');
          if (nav) new MutationObserver(function () { scheduleFix(700); }).observe(nav, { attributes: true, attributeFilter: ['data-sliderule-pane'] });
        }
      }
      if (MQ.addEventListener) MQ.addEventListener('change', schedule);
      schedule();
      scheduleFix(300);
      setTimeout(schedule, 300);
      setTimeout(schedule, 900);
      setTimeout(fixMenuHeight, 900);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    window.addEventListener('load', init);
  } catch (e) {
    /* sin ajustes propios: el menú sigue funcionando igual */
  }
})();
